(function () {
  'use strict';

  var CAMPAIGN = 'cart-gwp';
  var busy = false;

  function getApi() {
    return window.liquidAjaxCart;
  }

  function getCart() {
    var api = getApi();
    return api && api.cart ? api.cart : null;
  }

  function getRoots() {
    return Array.from(document.querySelectorAll('[data-cart-gwp]'));
  }

  function giftItems(cart) {
    return cart && Array.isArray(cart.items)
      ? cart.items.filter(function (item) {
          return item.properties && item.properties._gwp_campaign === CAMPAIGN;
        })
      : [];
  }

  function setBusy(value) {
    busy = value;
    getRoots().forEach(function (root) {
      root.toggleAttribute('aria-busy', value);
    });
  }

  function setMessage(message) {
    getRoots().forEach(function (root) {
      var output = root.querySelector('[data-cart-gwp-message]');
      if (output) output.textContent = message || '';
    });
  }

  function fallbackMessage(type) {
    var root = getRoots()[0];
    if (!root) return '';
    return type === 'paid' ? root.dataset.gwpPaidError : root.dataset.gwpError;
  }

  function requestMessage(state) {
    var response = state && state.responseData && state.responseData.body;
    if (!response) return fallbackMessage('error');
    if (typeof response.description === 'string') return response.description;
    if (typeof response.message === 'string') return response.message;
    if (typeof response.errors === 'string') return response.errors;
    return fallbackMessage('error');
  }

  function removeItems(items, callback) {
    var api = getApi();
    var queue = items.slice();

    if (!api || !api.change) {
      setBusy(false);
      setMessage(fallbackMessage('error'));
      return;
    }

    function next() {
      var item = queue.shift();
      if (!item) {
        if (callback) callback();
        return;
      }

      var body = new FormData();
      body.set('id', item.key);
      body.set('quantity', '0');

      api.change(body, {
        info: { initiator: 'cart-gwp' },
        lastCallback: function (state) {
          if (!state.responseData || !state.responseData.ok) {
            setBusy(false);
            setMessage(requestMessage(state));
            return;
          }
          next();
        }
      });
    }

    next();
  }

  function selectedVariant(choice) {
    var control = choice && choice.querySelector('[data-cart-gwp-variant]');
    return control ? control.value : '';
  }

  function chooseGift(checkbox) {
    var api = getApi();
    var cart = getCart();
    var choice = checkbox.closest('[data-cart-gwp-choice]');
    var variantId = selectedVariant(choice);

    if (!api || !api.add || !cart || !choice || !variantId) {
      checkbox.checked = false;
      setMessage(fallbackMessage('error'));
      return;
    }

    setBusy(true);
    setMessage('');

    document.querySelectorAll('[data-cart-gwp-checkbox]').forEach(function (other) {
      if (other !== checkbox) other.checked = false;
    });

    removeItems(giftItems(cart), function () {
      var body = new FormData();
      body.set('id', variantId);
      body.set('quantity', '1');
      body.set('properties[_gwp_campaign]', CAMPAIGN);
      body.set('properties[_gwp_product_id]', choice.dataset.productId || '');

      api.add(body, {
        info: { initiator: checkbox },
        lastCallback: function (state) {
          setBusy(false);
          if (!state.responseData || !state.responseData.ok) {
            setMessage(requestMessage(state));
            return;
          }
          enforceGiftRules(getCart());
        }
      });
    });
  }

  function clearGift() {
    var cart = getCart();
    if (!cart) return;
    setBusy(true);
    setMessage('');
    removeItems(giftItems(cart), function () {
      setBusy(false);
    });
  }

  function syncVariantPrice(select) {
    var choice = select.closest('[data-cart-gwp-choice]');
    var selected = select.options && select.options[select.selectedIndex];
    var price = choice && choice.querySelector('[data-cart-gwp-price]');
    if (selected && price && selected.dataset.price) {
      price.textContent = selected.dataset.price;
    }
  }

  function invalidGiftItems(cart) {
    var items = giftItems(cart);
    var root = getRoots()[0];
    var qualified = root && root.dataset.gwpQualified === 'true';

    if (!qualified) return items;

    return items.filter(function (item, index) {
      return index > 0 || item.final_line_price > 0 || item.quantity > 1;
    });
  }

  function enforceGiftRules(cart) {
    if (busy || !cart) return;
    var invalid = invalidGiftItems(cart);
    if (!invalid.length) return;

    setBusy(true);
    removeItems(invalid, function () {
      setBusy(false);
      setMessage(fallbackMessage('paid'));
    });
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest && event.target.closest('[data-cart-gwp-checkbox]');
    if (checkbox) {
      if (busy) return;
      if (checkbox.checked) chooseGift(checkbox);
      else clearGift();
      return;
    }

    var select = event.target.closest && event.target.closest('select[data-cart-gwp-variant]');
    if (!select) return;
    syncVariantPrice(select);

    var choice = select.closest('[data-cart-gwp-choice]');
    var selectedCheckbox = choice && choice.querySelector('[data-cart-gwp-checkbox]:checked');
    if (selectedCheckbox && !busy) chooseGift(selectedCheckbox);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;

    var cart = getCart();
    var invalid = invalidGiftItems(cart);
    if (!invalid.length) return;

    event.preventDefault();
    setBusy(true);
    removeItems(invalid, function () {
      setBusy(false);
      setMessage(fallbackMessage('paid'));
    });
  }, true);

  document.addEventListener('liquid-ajax-cart:init', function () {
    enforceGiftRules(getCart());
  });

  document.addEventListener('liquid-ajax-cart:request-end', function (event) {
    var cart = event.detail && event.detail.cart ? event.detail.cart : getCart();
    enforceGiftRules(cart);
  });

  if (document.readyState !== 'loading') {
    enforceGiftRules(getCart());
  }
})();
